// extracted by mini-css-extract-plugin
export default {"root":"Ybhouw4sUO","root_border":"azNlBj60kU"};